module.exports = __webpack_public_path__ + "instagram.webp?a56e00be7f993816e3c80f3a102df516";